// @ts-nocheck
import React from "react";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Radio, Col, Row } from "antd";
import { AmountRadio } from "../../Wrapper";
import { Box } from "src/components/Core/Box";
import { ages } from "src/constants/account";
import { Field } from "src/components/Forms/Field";
import { FormikProps } from "formik";
import { FormikInputNumber } from "src/components/Forms/TextInputNumber";
import { FormikSelect } from "src/components/Forms/Select";
import ClearButton from "./ClearButton";

interface Props {
  formProps: FormikProps<any>;
  collapsed: any;
  clearFilterKey: (key: string) => void;
}

const AgeAudience: React.FC<Props> = ({
  formProps,
  collapsed,
  clearFilterKey,
}) => {
  const fieldValue = formProps?.values;

  let isVisible = false;
  let backgroundColor = "#FFFFFF";

  if (fieldValue?.ageAudience?.age !== "") {
    isVisible = true;
    backgroundColor = "#FAFAFA";
  }

  return (
    <Box background={backgroundColor} padding="5px">
      <Row gutter={8}>
        <Field
          label="Age:"
          mb={20}
          extra={
            <ClearButton
              isVisible={isVisible}
              buttonClick={() => {
                formProps?.setFieldValue("ageAudience.age", "");
                formProps?.setFieldValue("ageAudience.count", 0);
                formProps?.setFieldValue("ageAudience.ageIsgreaterThan", true);
                clearFilterKey("audienceAge");
              }}
            />
          }
        >
          <Col span={collapsed ? 12 : 24}>
            <Box mb={collapsed ? 0 : 10}>
              <FormikSelect
                name="ageAudience.age"
                data={ages}
                local
                borderRadius={3}
                borderColor="grey5"
                size="middle"
              />
            </Box>
          </Col>

          <Col span={collapsed ? 12 : 24}>
            <AmountRadio>
              <Radio.Button
                value={false}
                onChange={value => {
                  if (
                    fieldValue?.ageAudience?.count ||
                    fieldValue?.ageAudience?.count === 0
                  ) {
                    formProps?.setFieldValue(
                      "ageAudience.ageIsgreaterThan",
                      false
                    );
                  }
                }}
                checked={fieldValue?.ageAudience?.ageIsgreaterThan === false}
              >
                <LeftOutlined />
              </Radio.Button>
              <Radio.Button
                value={true}
                onChange={value => {
                  if (
                    fieldValue?.ageAudience?.count ||
                    fieldValue?.ageAudience?.count === 0
                  ) {
                    formProps?.setFieldValue(
                      "ageAudience.ageIsgreaterThan",
                      true
                    );
                  }
                }}
                checked={fieldValue?.ageAudience?.ageIsgreaterThan === true}
              >
                <RightOutlined />
              </Radio.Button>
            </AmountRadio>

            <FormikInputNumber
              parser={value => {
                let parsed = value.replace(/\[0-9]/g, "");
                if (parsed) {
                  return parsed.match(/\d+/g) ? parseInt(parsed) : "";
                } else {
                  return null;
                }
              }}
              name="ageAudience.count"
              borderRadius={3}
              borderColor="grey5"
              size="small"
              value={fieldValue?.ageAudience?.count}
              style={{ marginLeft: 5, width: `${collapsed ? 72 : 105}px` }}
            />
          </Col>
        </Field>
      </Row>
    </Box>
  );
};

export default AgeAudience;
